// app/javascript/packs/routes/FileParser.jsx

import React, {useState, useEffect} from 'react';
// csv-parse v4 exposes the parse function as the module's default export
// (module.exports = parse), so a namespace import has no `.parse` member.
import parse from 'csv-parse/lib/browser/index.js';
import { Table } from 'react-bootstrap';

export function useFileParser(initialFile) {
  const [file, setFile] = useState(initialFile)
  const [parsedData, setParsedData] = useState(null)
  const [parsed, setParsed] = useState(false)
  const [errors, setErrors] = useState(null)
  const [options, setOptions] = useState({})

  const reader = new FileReader();

  reader.onabort = () => console.log("file reading was aborted");
  reader.onerror = () => console.log("file reading failed");
  reader.onload = () => {
    // Parse CSV file
    parse(reader.result, (err, data) => {

      console.log("Parsed CSV data: ", data);
      setParsedData(data)
      setErrors(err)
    });
  };

  useEffect(() => {
    setParsed(false)
    file && reader.readAsBinaryString(file)
  }, [file])

  useEffect(() => {
    if (parsedData) {
      const headerRow = parsedData[0]
      const headerDetected = headerRow.map(x=> !!parseFloat(x)).filter(Boolean).length < 2
      let newOpts = {headerDetected, columns: headerRow.length}
      if (headerDetected) {
        newOpts["headers"] = headerRow
      }
      setOptions({...options, ...newOpts})
      setParsed(true)
    }
  }, [parsedData])

  function filePreview(props) {
    const header = props.header || parsedData[0]
    const startIndex = props.header ? 0 : 1
    const content = parsedData.slice(startIndex, startIndex + props.maxLength)

    return <Table style={props.style} striped bordered size="sm" variant="dark">
      <thead>
        <tr>{header.map( (h, i) => <th key={i}>{h}</th>)}</tr>
      </thead>
      <tbody>
        {content.map((row, i) => <tr key={i}>{row.map((cell, j) => <td key={j}>{cell}</td>)}</tr>)}
      </tbody>
    </Table>
  }

  return {
    parsed: parsed,
    parsedData: parsedData,
    parsingErrors: errors,
    setFileToParse: setFile,
    parsingAttributes: options,
    FilePreview: filePreview
  }
}
